export default class Stack<T> implements StackClass<T> {
	_stack: T[] = [];

	constructor(maxLength?: number) {
		this._maxLength = maxLength;
	}

	_maxLength: number | undefined;

	get maxLength(): number | undefined {
		return this._maxLength;
	}

	set maxLength(value: number | undefined) {
		this._maxLength = value;
	}

	get length(): number {
		return this._stack.length;
	}

	get isEmpty(): boolean {
		return this._stack.length === 0;
	}

	get isFull(): boolean {
		return this._maxLength !== undefined && this._stack.length === this._maxLength;
	}

	public push(item: T): void {
		if (this._maxLength !== undefined && this._stack.length === this._maxLength) {
			this._stack.shift();
		}
		this._stack.push(item);
	}

	public pop(): T | undefined {
		return this._stack.pop();
	}

	public peek(): T | undefined {
		return this._stack[this._stack.length - 1];
	}

	public clear(): void {
		this._stack = [];
	}

	public toArray(): T[] {
		return this._stack;
	}

	public toString(): string {
		return this._stack.toString();
	}
}

/* -------------------  Stack ------------------- */
globalThis.Stack = function <T>(maxLength?: number): StackClass<T> {
	return new Stack<T>(maxLength);
};
